import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaExternalLinkAlt } from 'react-icons/fa';

const projectsData = [
        {
            "id" : 1,
            "title" : "Sales Architects - Consulting Platform",
            "url" : "https://www.salesarchitects.com/",
            "category" : "Consulting",
            "system_type" : "CMS Platform",
            "work_type" : "Custom CMS, API Integration",
            "technologies" : "WordPress, PHP, Migrationg from Core PHP to WordPress, APIs, REST Integration",
            "description" : "Developed a custom CMS with a client dashboard and API integrations, ensuring high performance and secure client communication."
        },
        {
            "id" : 2,
            "title" : "The Forte School - Art School Platform",
            "url" : "https://theforteschool.org/",
            "category" : "Education",
            "system_type" : "Management Platform",
            "work_type" : "Custom CMS Development, School Management System, Role-based Access Control, Dashboard Design",
            "technologies" : "WordPress, Custom PHP, MySQL",
            "description" : "Built a scalable school management system with student registration, scheduling, and administrative dashboards."
        },
        {
            "id" : 3,
            "title" : "GiftDaddy - Subscription Service",
            "url" : "https://www.giftdaddy.com/",
            "category" : "E-commerce",
            "system_type" : "Subscription SaaS",
            "work_type" : "SaaS Subscription Engine, API Integration, Payment Automation, Backend Optimization",
            "technologies" : "WordPress, CodeIgniter, MySQL",
            "description" : "Engineered a subscription-based e-commerce platform with automated billing, order tracking, and seamless API integration."
        },
        {
            "id" : 4,
            "title" : "Infertility Aide - Healthcare Service",
            "url" : "https://www.infertilityaide.com/",
            "category" : "Healthcare",
            "system_type" : "Healthcare Platform",
            "work_type" : "Healthcare Backend Architecture, Secure API, Data Privacy & Compliance, Automated Workflows",
            "technologies" : "WordPress, Core PHP, MySQL, Social Media integration",
            "description" :  "Developed a secure healthcare platform for patient management and clinic services, with API support and privacy compliance."
        },
        {
            "id" : 5,
            "title" : "SkitSkot - Entertainment Platform",
            "url" : "https://www.skitskot.com/",
            "category" : "Entertainment",
            "system_type" : "Media Platform",
            "work_type" : "API-driven Platform, Scalable Backend Architecture, Media Streaming Optimization, Queue Workers",
            "technologies" : "Laravel, MySQL, Redis, Queue Workers",
            "description" : "Created a scalable entertainment platform with API-driven content management and performance-optimized backend."
        },
        {
            "id" : 6,
            "title" : "Brimstone Retreats - Lodging Service",
            "url" : "https://www.brimstoneretreats.com/",
            "category" : "Travel & Hospitality",
            "system_type" : "Booking Platform",
            "work_type" : "Booking System, API, Dashboard",
            "technologies" : "Laravel, Event Management, Notification System, Redis, MySQL Optimization",
            "description" : "Built a complete hotel booking system with real-time availability checks, caching layers for performance, automated email jobs, and secure online payments."
        },
        {
            "id" : 7,
            "title" : "DropWave - SaaS Podcast Hosting",
            "url" : "https://dropwave.io/",
            "category" : "Media SaaS",
            "system_type" : "SaaS Platform",
            "work_type" : "SaaS Development, API, Dashboard, Cloud Deployment",
            "technologies" : "Laravel, Tailwind, AWS S3, DigitalOcean, Redis, Queue Workers, Subscriptions",
            "description" : "Designed and developed a scalable SaaS podcast hosting platform. Implemented multi-tenant architecture, automated audio processing jobs, Redis queues, and AWS S3 integration for large-scale media storage."
        },
        {
            "id" : 8,
            "title" : "Coding Help Solutions - Technical Blog",
            "url" : "https://codinghelpsolutions.com/",
            "category" : "Blog",
            "system_type" : "CMS",
            "work_type" : "Custom CMS, Performance Optimization, SEO-friendly Architecture, Content Management System",
            "technologies" : "WordPress, PHP, MySQL",
            "description" : "Built a technical blog with custom themes, optimized performance, and a focus on knowledge-sharing for developers."
        }
];
const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [activeFilter, setActiveFilter] = useState('All');

  useEffect(() => {
    setProjects(projectsData);
    setFilteredProjects(projectsData);
  }, []);



  const categories = ['All', ...new Set(projects.map(project => project.category))];

  const filterProjects = (category) => {
    setActiveFilter(category);
    if (category === 'All') {
      setFilteredProjects(projects);
    } else {
      setFilteredProjects(projects.filter(project => project.category === category));
    }
  };

  const getTechColor = (tech) => {
    const colors = {
      'Laravel': 'bg-red-100 text-red-800',
      'WordPress': 'bg-blue-100 text-blue-800',
      'PHP': 'bg-purple-100 text-purple-800',
      'CodeIgniter': 'bg-green-100 text-green-800',
      'Core PHP': 'bg-indigo-100 text-indigo-800'
    };
    
    for (let key in colors) {
      if (tech.includes(key)) {
        return colors[key];
      }
    }
    return 'bg-gray-100 text-gray-800';
  };

  const previewThemes = [
    'from-slate-900 via-slate-800 to-slate-700',
    'from-blue-900 via-indigo-800 to-indigo-700',
    'from-emerald-900 via-teal-800 to-cyan-700',
    'from-zinc-900 via-zinc-800 to-zinc-700',
  ];

  const getDomain = (url) => {
    try {
      return new URL(url).hostname.replace('www.', '');
    } catch {
      return url;
    }
  };

  return (
    <section id="projects" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-gray-900 mb-4">
            Portfolio Projects
          </h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto mb-6"></div>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            A showcase of my professional work across various industries and technologies.
          </p>
        </motion.div>

        {/* Filter Buttons */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="flex flex-wrap justify-center gap-4 mb-12"
        >
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => filterProjects(category)}
              className={`px-6 py-2 rounded-full font-medium transition-all duration-300 ${
                activeFilter === category
                  ? 'bg-blue-600 text-white shadow-md'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {category}
            </button>
          ))}
        </motion.div>

        {/* Projects Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProjects.map((project, index) => (
            <motion.div
              key={project.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -4, scale: 1.01 }}
              className="bg-white rounded-xl shadow-md hover:-translate-y-2 transition-all duration-300 overflow-hidden group"
            >
              {/* Project Preview */}
              <div className="relative h-48 overflow-hidden">
                {project.screenshot ? (
                  <>
                    <img
                      src={project.screenshot}
                      alt={`${project.title} preview`}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                    <div className="absolute top-4 right-4 z-10">
                      <span className="bg-white/90 text-gray-800 px-3 py-1 rounded-full text-xs font-semibold">
                        {project.category}
                      </span>
                    </div>
                    <div className="absolute bottom-4 left-4 right-4 z-10">
                      <h3 className="text-white text-lg font-semibold tracking-tight">
                        {project.title.split(' - ')[0]}
                      </h3>
                    </div>
                  </>
                ) : (
                  <div
                    className={`w-full h-full bg-gradient-to-br ${previewThemes[project.id % previewThemes.length]} p-5 flex flex-col justify-between transition-transform duration-500 group-hover:scale-105`}
                  >
                    <div className="flex items-center justify-between">
                      <img
                        src={`https://www.google.com/s2/favicons?domain=${getDomain(project.url)}&sz=128`}
                        alt={`${project.title} favicon`}
                        className="w-10 h-10 rounded-lg bg-white p-1"
                        loading="lazy"
                      />
                      <span className="text-white/80 text-xs font-medium">
                        Live Project
                      </span>
                    </div>
                    <div>
                      <span className="inline-block bg-white/20 text-white px-2.5 py-1 rounded-full text-xs font-semibold mb-3">
                        {project.category}
                      </span>
                      <p className="text-white/70 text-xs uppercase tracking-wider mb-1">
                        {getDomain(project.url)}
                      </p>
                      <h4 className="text-white text-lg font-semibold leading-tight">
                        {project.title.split(' - ')[0]}
                      </h4>
                    </div>
                  </div>
                )}
              </div>

              {/* Project Content */}
              <div className="p-6 space-y-4">
                <h3 className="text-xl font-bold tracking-tight text-gray-900 group-hover:text-blue-600 transition-colors">
                  {project.title}
                </h3>

                {project.description && (
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {project.description}
                  </p>
                )}

                {/* Type and Work */}
                <div className="space-y-2">
                  <p className="text-xs uppercase tracking-wide text-gray-500 font-semibold">System Type</p>
                  <p className="text-sm font-semibold text-gray-800">{project.system_type}</p>
                  <p className="text-xs uppercase tracking-wide text-gray-500 font-semibold pt-1">Work Scope</p>
                  <p className="text-sm text-gray-700">{project.work_type}</p>
                </div>

                {/* Technologies */}
                <div>
                  <p className="text-xs uppercase tracking-wide text-gray-500 font-semibold mb-2">Technologies Used</p>
                  <div className="flex flex-wrap gap-2">
                    {project.technologies.split(/[,+]/).map((tech, techIndex) => (
                      <span
                        key={techIndex}
                        className={`px-3 py-1 rounded-full text-xs font-medium ${getTechColor(tech.trim())}`}
                      >
                        {tech.trim()}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Project Link */}
                <a
                  href={project.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-blue-600 hover:text-blue-700 font-semibold group-hover:underline transition-all duration-300 pt-1"
                >
                  <span>View Project</span>
                  <FaExternalLinkAlt className="ml-2 text-sm" />
                </a>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Projects Summary */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          viewport={{ once: true }}
          className="mt-16 bg-gray-50 p-8 rounded-xl shadow-md"
        >
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Project Highlights
            </h3>
            <p className="text-gray-600 max-w-2xl mx-auto">
              My portfolio showcases diverse projects across multiple industries, 
              demonstrating expertise in full-stack development and various technologies.
            </p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
            <div>
              <div className="text-3xl font-bold text-blue-600 mb-2">9+</div>
              <div className="text-gray-600">Live Projects</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-blue-600 mb-2">5</div>
              <div className="text-gray-600">Industries</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-blue-600 mb-2">Full-Stack</div>
              <div className="text-gray-600">Development</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-blue-600 mb-2">API</div>
              <div className="text-gray-600">Integration</div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Projects;
